




import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {PickingListDeliveryStatus} from "@/enums/status";
import {IdMapper} from "@/interfaces/state/base";

@Component({
  name: 'PLDeliveryStatusLabel'
})
export default class extends mixins(CommonMixin) {
  @Prop({ required: true, type: Number }) readonly status!: number;
  PickingListDeliveryStatus = PickingListDeliveryStatus;
  colorMap: IdMapper<string> = {
    [PickingListDeliveryStatus.WaitingConfirm]: 'warning',
    [PickingListDeliveryStatus.Confirmed]: 'success',
    [PickingListDeliveryStatus.Reject]: 'error',
  }
}
